var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"toolbar"},[(this.title)?_c('i',{staticClass:"fa",class:_vm.icon}):_vm._e(),_c('span',{staticClass:"title"},[_vm._v(_vm._s(this.title))]),_vm._v(" "),(_vm.back)?_c('el-button',{attrs:{"type":"danger"},on:{"click":_vm.backFun}},[_vm._v("返回")]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6deb15e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CHead.vue
// module id = null
// module chunks = 